export default __webpack_public_path__ + "static/media/3-3-3.1869f074.jpg";